import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, null, -1)
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "col-12"
}
const _hoisted_6 = {
  class: "card col-8 offset-2",
  style: {"margin-bottom":"2%"}
}
const _hoisted_7 = { style: {"display":"inline-block","position":"absolute","width":"100%","top":"20%"} }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = {
  key: 0,
  class: "offset-2 col-4 float-start"
}
const _hoisted_10 = {
  key: 1,
  class: "col-2 float-start"
}
const _hoisted_11 = {
  key: 2,
  class: "col-3 float-start",
  style: {"text-align":"left"}
}
const _hoisted_12 = {
  style: {"text-align":"left"},
  class: "col-6 offset-3"
}
const _hoisted_13 = { style: {"list-style":"none"} }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { style: {"display":"grid"} }
const _hoisted_16 = { id: "editor-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editor = _resolveComponent("Editor")!
  const _component_EMailEditor = _resolveComponent("EMailEditor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumb, (dir, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            onClick: ($event: any) => (_ctx.navigateToBreadcrumb(index)),
            class: _normalizeClass({ clickable: index < _ctx.breadcrumb.length - 1 })
          }, [
            _createTextVNode(_toDisplayString(dir) + " ", 1),
            (index < _ctx.breadcrumb.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " / "))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 128))
      ]),
      (_ctx.uploadable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.uploadFileName), 1),
              _createElementVNode("label", {
                class: _normalizeClass([{ over: _ctx.isDragOver }, "fileuploadlabel input-item__label"]),
                onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onDrag(true)), ["prevent"])),
                onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onDrag(false)), ["prevent"])),
                onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
                style: {"font-size":"24px","cursor":"pointer","line-height":"100px","z-index":"9"}
              }, [
                _createElementVNode("input", {
                  onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeUploadinput && _ctx.changeUploadinput(...args))),
                  type: "file"
                }, null, 32)
              ], 34)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.uploadable)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newDir) = $event)),
                type: "text",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.newDir]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.uploadable)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createDir && _ctx.createDir(...args)))
              }, "ディレクトリの作成")
            ]))
          : _createCommentVNode("", true),
        (_ctx.uploadable)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-danger btn-sm",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteDir && _ctx.deleteDir(...args)))
              }, "このディレクトリを削除")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("ul", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesAndFolders, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              style: {"cursor":"pointer"},
              key: index,
              onClick: ($event: any) => (_ctx.onSelectFile(item))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(item.type)
              }, _toDisplayString(item.name), 3)
            ], 8, _hoisted_14))
          }), 128))
        ])
      ]),
      (_ctx.showPopup)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: {"z-index":"99","height":"100%","top":"0","position":"fixed"},
            class: "popup-overlay",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
          }, [
            _createElementVNode("div", {
              class: "popup-content",
              onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("p", null, _toDisplayString(_ctx.selectedFile?.name), 1),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.isEditableFile&&_ctx.editable)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onEdit && _ctx.onEdit(...args)))
                    }, "編集"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onDownload && _ctx.onDownload(...args)))
                }, "ダウンロード"),
                (_ctx.deletable)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deleteFile && _ctx.deleteFile(...args)))
                    }, "削除"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
                }, "閉じる")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showEditorPopup)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: {"z-index":"99","height":"100%","top":"0","position":"fixed"},
          class: "editor-popup-overlay",
          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeEditorPopup && _ctx.closeEditorPopup(...args)))
        }, [
          _createElementVNode("div", {
            class: "editor-popup-content",
            onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_16, [
              (_ctx.lookAtFileExtension !== 'eml')
                ? (_openBlock(), _createBlock(_component_Editor, {
                    key: 0,
                    onShowLoader: _ctx.showLoader,
                    onShowFlash: _ctx.showFlash,
                    onCloseEditor: _ctx.closeEditor,
                    params: {path: _ctx.filePath , ext : _ctx.lookAtFileExtension }
                  }, null, 8, ["onShowLoader", "onShowFlash", "onCloseEditor", "params"]))
                : _createCommentVNode("", true),
              (_ctx.lookAtFileExtension === 'eml')
                ? (_openBlock(), _createBlock(_component_EMailEditor, {
                    key: 1,
                    onShowLoader: _ctx.showLoader,
                    onShowFlash: _ctx.showFlash,
                    onCloseEditor: _ctx.closeEditor,
                    params: {path: _ctx.filePath , ext : _ctx.lookAtFileExtension }
                  }, null, 8, ["onShowLoader", "onShowFlash", "onCloseEditor", "params"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeEditorPopup && _ctx.closeEditorPopup(...args)))
            }, "Close Editor")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}